import PropTypes from 'prop-types';
import TrainingVideoProps from './TrainingVideo';

export default {
  id: PropTypes.number,
  name: PropTypes.string,
  videos: PropTypes.arrayOf(
    PropTypes.shape(TrainingVideoProps)
  )
};